const detailList = [
  {
    id: 1,
    list: [
      {
        nameid: 1,
        name: '一、发生在招标环节的案例解析',
        children: [{
            name: '1、合情与合法－采购需求应当合法',
          },
          {
            name: '2、概念之争－采购需求应当合规',
          },
          {
            name: '3、不符合要求的档案盒－采购需求应当完整',
          },
          {
            name: '4、欧盟认证证书－采购需求应当明确',
          },
          {
            name: '5、招标文件指向了谁－不得以不合理条件对供应商实行差别待遇或者歧视待遇',
          },
        ]
      },
      {
        nameid: 2,
        name: '二、发生在投标环节的案例解析',
        children: [{
            name: '1、合同章与公章的纠结－资格审查',
          },
          {
            name: '2、允许迟到供应商投标引发的麻烦－开标时间、地点',
          },
          {
            name: '3、补交的检测报告－应当按照招标文件明确响应',
          },
          {
            name: '4、20天之差－如何认定投标文件存在重大负偏离',
          },
          {
            name: '5、画蛇添足 多加一句话引来的麻烦－答疑与澄清',
          },
          {
            name: '6、错失的质疑权－质疑时限',
          },
          {
            name: '7、无据的投诉－“地方保护”',
          },
          {
            name: '8、标书粘贴错误该如何处理－违法认定',
          },
        ]
      },
      {
        nameid: 3,
        name: '三、发生在评标环节的案例解析',
        children: [{
            name: '1、少一个环节 多一场官司合情－实质性条款',
          },
          {
            name: '2、心软的代价－非实质性条款',
          },
          {
            name: '3、样品惹的祸－评标、样品、鉴定',
          },
          {
            name: '4、技术指标是否响应谁说了算－评标、方法、标准',
          },
          {
            name: '5、“唯一”的供应商－竞争性谈判的适用',
          },
          {
            name: '6、废标权之争－投标无效',
          },
        ]
      },
      {
        nameid: 4,
        name: '四、发生在中标环节的案例解析',
        children: [{
            name: '1、采购人能否自请专家重新审核中标方案－拒签合同处理',
          },
          {
            name: '2、考察中标供应商 采购人为何遭拒－不得通过考察改变中标结果',
          },
        ]
      },
      {
        nameid: 5,
        name: '五、供应商违法违规的案例解析',
        children: [{
            name: '1、可惜！痛惜－供应商提供虚假材料谋取中标',
          },
          {
            name: '2、真假合同－调查取证、暂停采购活动、终止投诉程序、依法处理',
          },
          {
            name: '3、罚还是不罚－供应商提供虚假材料如何处理',
          },
          {
            name: '4、“莫须有”的中标产品－确定采购需求、公平竞争、依法评审',
          },
          {
            name: '5、“告”出一个中标来－重新确定中标人、重新开展采购活动（内容需要根据财政部最新答复补充）',
          },
        ]
      },
      {
        nameid: 6,
        name: '六、质疑投诉处理的案例解析',
        children: [{
            name: '1、依法行政－违法违规认定',
          },
          {
            name: '2、以“法”服人－委托代理、自行采购',
          },
          {
            name: '3、依法处理－联合体、恶意串通、质疑投诉诉讼',
          },
          {
            name: '4、用证据说话－监督检查、依法处理',
          },
          {
            name: '5、何为重大－重大违法记录',
          },
          {
            name: '6、“10%”的艺术－单一来源采购 ',
          },
          {
            name: '7、两难的采购项目－信息公告、同品牌多投标人认定',
          },
          {
            name: '8、依法处理 不惧“风波”－依法妥善处理 ',
          },
        ]
      },
      {
        nameid: 7,
        name: '七、其他',
        children: [{
            name: '1、拒绝背黑锅－政府采购不再沉默',
          },
          {
            name: '2、分散采购不是自由采购－分散采购、涉密采购',
          },
          {
            name: '3、“意外”的诉讼－送达 ',
          },
          {
            name: '4、评标的“秘密”－信息公开',
          },
        ]
      },
    ]
  },
  {
    id: 2,
    list: [{
        name: '1、招标采购法律法规与政策体系的构成',
      },
      {
        name: '2、强制招标制度',
      },
      {
        name: '3、依法必招项目判定思考',
      },
      {
        name: '4、工程项目招投标领域营商环境专项整治工作方案',
      },
      {
        name: '5、企业招标采购制度建设',
      },
      {
        name: '6、国有企业采购内控制度建设',
      },
      {
        name: '7、招标文件编制过程中存在的主要问题及风险防范',
      },
      {
        name: '8、招标过程中存在的主要问题及风险防范',
      },
      {
        name: '9、依法必须进行招标的项目与自愿招标的项目的主要区别',
      },
    ]
  },
  {
    id: 2,
    list: [{
        name: '1、评标依据',
      },
      {
        name: '2、评标委员会',
      },
      {
        name: '3、招标人与评委的关系',
      },
      {
        name: '4、无效标的认定',
      },
      {
        name: '5、计算性算术错误修正',
      },
      {
        name: '6、投标文件澄清和说明',
      },
      {
        name: '7、经评审最低投标价法',
      },
      {
        name: '8、开标中的评标问题',
      },
      {
        name: '9、分包情形评审',
      },
    ]
  },
  {
    id: 2,
    list: [{
        name: '1、交易平台',
      },
      {
        name: '2、公共服务平台',
      },
      {
        name: '3、电子招标投标行政监督及创新网络条件下的行政监督',
      },
      {
        name: '4、电子招标投标的标准化、信息化',
      },
      {
        name: '5、电子招标投标系统检测认证',
      },
    ]
  },
  {
    id: 1,
    list: [
      {
        nameid: 1,
        name: '一、海洋资源交易',
        children: [{
            name: '1、海域使用权出让',
          },
          {
            name: '2、无居民海岛等海洋资源使用权出让',
          },
        ]
      },
      {
        nameid: 2,
        name: '二、林权交易',
        children: [{
            name: '1、国有林地使用权、租赁权和林木所有权出让',
          },
          {
            name: '2、集体统一经营管理的林地经营权和林木所有权出让',
          },
        ]
      },
      {
        nameid: 3,
        name: '三、农村集体产权交易',
        children: [{
            name: '1、农村集体土地经营权流转',
          },
          {
            name: '2、农村集体经营性资产出租',
          },
          {
            name: '3、农村集体资产股权转让',
          },
          {
            name: '4、四荒（荒山，荒沟，荒丘，荒滩）地使用权流转',
          },
        ]
      },
      {
        nameid: 4,
        name: '四、无形资产交易',
        children: [{
            name: '1、基础设施和公共事业特许经营权授予',
          },
          {
            name: '2、市政公用设施及公共场地使用权，承包经营权',
          },
        ]
      },
      {
        nameid: 5,
        name: '五、排污权交易',
        children: [{
            name: '1、定额出让排污权',
          },
          {
            name: '2、公开拍卖排污权',
          },
        ]
      },
    ]
  },
  

]

export default detailList